import styled from 'styled-components'

interface IContainer {
  marginTop?: string
  marginRight?: string
  marginBottom?: string
  marginLeft?: string
  padding?: string
  width?: string
}
const Container = styled.div<IContainer>`
  margin-top: ${({ marginTop }) => marginTop || '0'};
  margin-right: ${({ marginRight }) => marginRight || '0'};
  margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
  margin-left: ${({ marginLeft }) => marginLeft || '0'};
  padding: ${({ padding }) => padding || '0'};
  width: ${({ width }) => width || '100%'};
`

export default Container
